import React from "react";
import { useDispatch } from "react-redux";
import { Cars } from "./Cars/Cars";
import {
  MAP_GLOBAL_STATES,
  FLEET_GLOBAL_STATES,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { Settings } from "./Settings/index";
import { Scorecards } from "./Scorecards";
import UsageReport from "./Usage";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setAppDataReduxStateAction, setSiteIdData } from "redux/reduxToolkitServices/_commonReducers/persistedLocalStorageReducer";

export const Fleet = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const {
    selectedCarList2,
    selectedCarListBackup,
    toggleSelectedCars,
    toggleUnselectedCars,
  } = useHookstate(FLEET_GLOBAL_STATES);

  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);

  // Handle siteId from URL query parameter
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const siteIdFromUrl = searchParams.get('siteId');
    
    if (siteIdFromUrl) {
      const parsedSiteId = parseInt(siteIdFromUrl, 10);
      siteId.set(parsedSiteId);
      localStorage.setItem("recentSite", siteIdFromUrl);
      
      // Update Redux state to sync with site dropdown
      dispatch(setAppDataReduxStateAction({ parameterDetector: "sitenumber", value: siteIdFromUrl }));
      dispatch(setSiteIdData(siteIdFromUrl));
    }
  }, [location.search]);

  useEffect(() => {
    let getSubnavName = localStorage.getItem("mapSideNavTabState");
    if (
      getSubnavName === "Usage" ||
      getSubnavName === "Cars" ||
      getSubnavName === "Scorecards" ||
      getSubnavName === "Settings"
    ) {
      mapSideNavTabState.set(localStorage.getItem("mapSideNavTabState"));
    } else {
      mapSideNavTabState.set("Cars");
      localStorage.setItem("mapSideNavTabState", "Cars");
    }
  }, []);

  useEffect(() => {
    if (selectedCarList2.get().length === selectedCarListBackup.get().length) {
      toggleSelectedCars.set(true);
    } else if (
      selectedCarList2.get().length !== selectedCarListBackup.get().length
    ) {
      toggleSelectedCars.set(false);
    } else if (selectedCarList2.get().length === 0) {
      toggleUnselectedCars.set(true);
    }
  }, [selectedCarList2.get()]);

  switch (mapSideNavTabState.get()) {
    case "Cars":
      return <Cars />;
    case "Usage":
      return <UsageReport />;
    case "Scorecards":
      return <Scorecards />;
    case "Settings":
      return <Settings />;
  }
};
